import { injectBaseConstantMethods } from "./BaseConstants"

const InventorySettings = {
   Timer: "Timer",
   DownpaymentAmount: "DownpaymentAmount",
   ProductionCost: "ProductionCost",
   MouldConfiguration: "MouldConfiguration",
   DailyConfiguration: "DailyConfiguration",
}

const displayTextKeys = {
   [InventorySettings.Timer]: "Timer",
   [InventorySettings.DownpaymentAmount]: "Downpayment Amount",
   [InventorySettings.ProductionCost]: "ProductionCost",
   [InventorySettings.MouldConfiguration]: "MouldConfiguration",
   [InventorySettings.DailyConfiguration]: "DailyConfiguration",
}

const labelClass = {
   [InventorySettings.Timer]: "Timer",
   [InventorySettings.DownpaymentAmount]: "Downpayment Amount",
   [InventorySettings.ProductionCost]: "ProductionCost",
   [InventorySettings.MouldConfiguration]: "MouldConfiguration",
   [InventorySettings.DailyConfiguration]: "DailyConfiguration",
}

export default injectBaseConstantMethods(
   InventorySettings,
   displayTextKeys,
   labelClass
)
